import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';

@Injectable()
export class MonthToDatesService {

	private value: number=0;

  constructor(private datePipe: DatePipe) {}


  public getDates(value: number, anio: number) {

  	this.value= value;
    //console.log(value);
    let from: Date = new Date();
    //from.setMonth(this.value);
    from.setFullYear(anio, value, 1);
    //from.setDate(1);

    let to: Date = new Date();
    this.value = Number(value) + 1;
    //to.setMonth(this.value);
    to.setFullYear(anio, this.value, 1);
    //to.setDate(1);
    
    //console.log(from);
    //console.log(to);

    return {
      from: this.datePipe.transform(from, 'yyyy-MM-dd'),
      to: this.datePipe.transform(to, 'yyyy-MM-dd')

    }

  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-poliflex-pipeline/src/app/services/month-to-dates.service.ts